import { saveVariantSlicerGridState as saveVariantSlicerGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveVariantSlicerGridState = ({
    columnState,
}: Props) => {
    saveVariantSlicerGridStateDiagram(columnState);
};
